import { render } from "./ModalCollectPayment.vue?vue&type=template&id=611384f4&scoped=true"
import script from "./ModalCollectPayment.vue?vue&type=script&lang=js"
export * from "./ModalCollectPayment.vue?vue&type=script&lang=js"

import "./ModalCollectPayment.vue?vue&type=style&index=0&id=611384f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611384f4"]])

export default __exports__